import {
    globalURL,
    fetchApiHeaders
} from "../../helpers/constants";
import {
    checkFormFields
} from "../../helpers/functions";

const setValue = (key, value) => dispatch => {
    dispatch({
        type: "SET_VALUE_SUBSCRIPTION",
        payload: {
            key: key,
            value: value
        }
    })
}

const sendSubscription = (data, addToast, strings) => dispatch => {
    dispatch({
        type: "GET_SUBSCRIPTION"
    })
    var checkForm = checkFormFields(data, true, strings);
    if (!checkForm.result) {
        fetch(globalURL + "/notifyList/create", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST
            },
            body: JSON.stringify({
                email: data[0].value,
            })
        })
            .then((result) => result.json())
            .then(async (subscription) => {
                if (subscription.success) {
                    addToast(strings['alerts']['subscriptionSuccess'], { appearance: "success", autoDismiss: true });
                    dispatch({
                        type: "FETCH_SUBSCRIPTION",
                        payload: subscription.data
                    })
                } else {
                    if (subscription.type === "exists") {
                        dispatch({
                            type: "SET_VALUE_ERROR_SUBSCRIPTION",
                            payload: {
                                key: "email",
                                helpertext: strings["alerts"]["emailExists"]
                            }
                        })
                    } else {
                        addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
                    }
                    dispatch({
                        type: "ERROR_SUBSCRIPTION",
                        payload: subscription
                    })
                }
            })
            .catch((error) => {
                addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
                dispatch({
                    type: "ERROR_SUBSCRIPTION",
                    payload: error
                })
            })
    } else {
        // null inputs
        checkForm.nullFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_SUBSCRIPTION",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        });

        checkForm.invalidFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_SUBSCRIPTION",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        })
    }
}


export {
    setValue,
    sendSubscription
}

